export interface IEnactPagesAccessKeys {
    current: boolean;
    'monthly-summary': boolean; // Not currently in enact backend page access
    dashboard: boolean;
    'storage-da-analysis': boolean;
    'boa-dashboard': boolean;
    'epex-grid': boolean;
    europeOverview: boolean;
    europeanAnalysis: boolean;
    valueStreamAnalysis: boolean;
    wholesaleData: boolean;
    universalExporter: boolean;
    'ancillary-contracts': boolean;
    'bingo-card': boolean;
    plantActivityBoard: boolean;
    'remit-summary': boolean;
    'weather-forecasting': boolean;
    'wind-forecasting': boolean;
    'map-page': boolean; // should this be map-live?
    'europe-map-page': boolean;
    'bingo-map': boolean;
    'zonal-build-up': boolean;
    'historic-analysis': boolean;
    'forecast-history': boolean;
    news: boolean;
    notifications: boolean;
    glossary: boolean;
    leaderboard: boolean;
    'flex-index': boolean;
    index: boolean;
    'bess-carbon-emissions-calculator': boolean;
    longTermPowerOverview: boolean;
    assets: boolean;
    marketAssumptions: boolean;
    capacityMarket: boolean;
    tnuos: boolean;
    tlms: boolean;
    outputs: boolean;
    comparison: boolean;
    forecastReport: boolean;
    assetTrackingOverview: boolean;
    marketTrends: boolean;
    rankings: boolean;
    companySearch: boolean;
    projectSearch: boolean;
    'plant-table': boolean;
    registers: boolean;
    customCharting: boolean;
    projectUpdates: boolean;
    admin: boolean;
    chat: boolean;
    accessLockedTbd: boolean;
    apiInstructions: boolean;
}

export interface IEnactPageAccessItem {
    hasAccess: boolean;
    noAccessMessage?: string;
}

export type IEnactPagesAccess = {
    [K in keyof IEnactPagesAccessKeys]: IEnactPageAccessItem;
};

const isProduction = import.meta.env.MODE === 'production';

export const defaultEnactPagesAccess: IEnactPagesAccess = {
    current: { hasAccess: !isProduction }, // should be true when live
    'monthly-summary': { hasAccess: false },
    dashboard: { hasAccess: false },
    'storage-da-analysis': { hasAccess: false },
    'boa-dashboard': { hasAccess: false },
    'epex-grid': { hasAccess: false },
    europeOverview: { hasAccess: !isProduction }, // should be true when live
    europeanAnalysis: { hasAccess: false },
    valueStreamAnalysis: { hasAccess: false },
    wholesaleData: { hasAccess: false },
    universalExporter: { hasAccess: false },
    'ancillary-contracts': { hasAccess: false },
    'bingo-card': { hasAccess: false },
    plantActivityBoard: { hasAccess: false },
    'remit-summary': { hasAccess: false },
    'weather-forecasting': { hasAccess: false },
    'wind-forecasting': { hasAccess: false },
    'map-page': { hasAccess: false },
    'europe-map-page': { hasAccess: false },
    'bingo-map': { hasAccess: false },
    'zonal-build-up': { hasAccess: false },
    'historic-analysis': { hasAccess: false },
    'forecast-history': { hasAccess: false },
    news: { hasAccess: false },
    notifications: { hasAccess: false },
    glossary: { hasAccess: !isProduction }, // should be true when live
    leaderboard: { hasAccess: false },
    'flex-index': { hasAccess: false },
    index: { hasAccess: true },
    'bess-carbon-emissions-calculator': { hasAccess: !isProduction }, // should be true when live
    longTermPowerOverview: { hasAccess: true },
    assets: { hasAccess: false },
    marketAssumptions: { hasAccess: false },
    capacityMarket: { hasAccess: false },
    tnuos: { hasAccess: false },
    tlms: { hasAccess: false },
    outputs: { hasAccess: false },
    comparison: { hasAccess: false },
    forecastReport: { hasAccess: false },
    assetTrackingOverview: { hasAccess: true },
    marketTrends: { hasAccess: false },
    rankings: { hasAccess: false },
    companySearch: { hasAccess: false },
    projectSearch: { hasAccess: false },
    'plant-table': { hasAccess: false },
    registers: { hasAccess: false },
    customCharting: { hasAccess: false },
    projectUpdates: { hasAccess: false },
    admin: { hasAccess: false },
    chat: { hasAccess: false },
    accessLockedTbd: { hasAccess: false },
    apiInstructions: { hasAccess: false },
};
